<template>
  <BaseModal title="发布 / 关联 / 置顶" v-model="show" :width="320">
    <div>
      <a-checkbox :checked="true" disabled>发布（发布的图片可供用户查看）</a-checkbox>
    </div>
    <div style="margin:10px 0;">
      <a-checkbox :checked="isTop" @change="setIsTop">置顶（勾选后可使图片置顶显示）</a-checkbox>
    </div>
    <div v-if="options.length"
         style="background:#eee;padding:20px;margin:20px 0;">
      <div style="color:#ff5500;">* 请勾选要关联的子相册</div>
      <a-checkbox-group v-model="folder_id">
        <div :key="index" style="margin: 10px 0;" v-for="(opt, index) in options">
          <a-checkbox :value="opt.value">{{ opt.label }}</a-checkbox>
        </div>
      </a-checkbox-group>
    </div>
    <div style="margin-top:20px;">
      <a-button @click="submit" icon="check" type="primary" size="large" shape="round" block>确认提交</a-button>
    </div>
  </BaseModal>
</template>

<script>
import api from "../../../../../utils/api";
import cache from "../../../../../utils/cache";
import BaseModal from "../../../../../comps/BaseModal";

export default {
  name: "ReleaseForm",
  components: {BaseModal},
  props: {albumId: String},
  data() {
    return {
      show: false,
      isTop: false,
      options: [],
      folder_id: [],
      selected: [],
    }
  },
  methods: {
    open(selected) {
      const self = this;
      cache.v1.album.folder.option(this.albumId)
          .then(res => {
            self.show = true;
            self.isTop = false;
            self.options = res;
            self.folder_id = [];
            self.selected = selected;
          });
    },
    submit() {
      const self = this;
      return this.doSubmit()
          .then(() => {
            self.show = false;
            self.$emit("saved");
            self.$message.success(`发布成功`)
          })
          .catch((err) => {
            console.log(err); // debug
            self.$message.success(`发布失败`)
          });
    },
    async doSubmit() {
      await api.v1.album.photo.action(this.albumId, this.selected, "release", true);
      if (this.isTop) await api.v1.album.photo.action(this.albumId, this.selected, "top", true);
      if (this.folder_id.length > 0) await api.v1.album.photo.link(this.albumId, this.selected, this.folder_id);
    },
    setIsTop(e) {
      this.isTop = e.target.checked;
    }
  }
}
</script>

<style scoped>

</style>
